import Card from '@zenbusiness/zui/Card';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const StyledCard = superstyled({
  tag: Card,
  name: 'NotificationCard',
  slot: 'StyledCard',
  styles: ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  }),
});

export const MessageText = superstyled({
  tag: Text,
  name: 'NotificationCard',
  slot: 'MessageText',
  styles: {
    whiteSpace: 'pre-line',
  },
});
